(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ManageColorModalController', ManageColorModalController);

    ManageColorModalController.$inject = ['$uibModalInstance', '$scope', '$state', 'color'];

    function ManageColorModalController($uibModalInstance, $scope, $state, color) {
        var vm = this;
        const DEFAULT_COLOR = '#BBBBBB';

        if (color) {
            color.id = color.id || '';
            color.hex = color.hex || DEFAULT_COLOR;
            color.name = color.name || '';
            color.erpCode = color.erpCode || '';
        }

        vm.isEdit = color ? true : false;

        if (vm.isEdit) {
            vm.colorData = {
                hex: color.hex || DEFAULT_COLOR,
                name: color.name || '',
                erpCode: color.erpCode || '',
                id: color.id || ''
            };
            vm.title = "flyers.new.form.color-modal.title-update";
            vm.button = "flyers.new.form.color-modal.update";
        } else {
            vm.colorData = {
                hex: DEFAULT_COLOR,
                name: '',
                erpCode: ''
            };
            vm.title = "flyers.new.form.color-modal.title";
            vm.button="flyers.new.form.color-modal.add";
        }

        setTimeout(function () {
            loadColorPicker();
        });

        vm.closeModal = function () {
            $uibModalInstance.close(false);
        }

        vm.saveColor = function () {
            $uibModalInstance.close(vm.colorData);
        }

        vm.changeColor = function (color) {
            var validColor = vm.pickr.setColor(color, true);
            if (validColor) {
                vm.pickr.applyColor(true)
                vm.colorForm.hex.$setValidity('invalidColor', true);
            } else vm.colorForm.hex.$setValidity('invalidColor', false);
        }

        function loadColorPicker() {
            vm.pickr = Pickr.create({
                el: '.color-picker',
                theme: 'monolith',
                default: vm.colorData.hex,
                swatches: ['#F44336', '#9C27B0', '#3F51B5',
                    '#03A9F4', '#009688', '#4CAF50', '#FFEB3B',
                    '#000000', '#3E3E3E', '#787878', '#A0A0A0',
                    '#AAAAAA', '#DEDEDE', '#FFFFFF'],
                components: {
                    opacity: false,
                    hue: true,
                    preview: true,
                    interaction: {
                        input: true,
                        save: true
                    }
                },

                i18n: {
                    'btn:save': 'Alterar',
                }
            });

            vm.pickr.on('change', function (color, instance) {
                vm.colorForm.hex.$setValidity('invalidColor', true);
            })

            vm.pickr.on('save', function (color, instance) {
                setColorInput(color)
                vm.pickr.hide();
            });
        }

        function setColorInput(color) {
            vm.colorData.hex = angular.copy(color.toHEXA().toString());
            $scope.$apply();
        }
    }
})();
